import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, ChevronDown, ChevronUp, ExternalLink, Calendar, Users, Building2, Image } from 'lucide-react';
import { resolveFileUrl } from '../../utils/fileUrl';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const TemplesPage = () => {
  const [expandedTemple, setExpandedTemple] = useState('raniwara');

  const toggleTemple = (id) => {
    setExpandedTemple(expandedTemple === id ? null : id);
  };

  const temples = [
    {
      id: 'raniwara',
      name: 'रानीवाड़ा धाम',
      nameEn: 'Raniwara Dham',
      location: 'रानीवाड़ा, जालोर जिला, राजस्थान',
      locationEn: 'Raniwara, Jalore District, Rajasthan',
      established: '1995 (प्राण प्रतिष्ठा 1997)',
      contact: ['8290712527', '02990-232527'],
      highlight: 'आधुनिक काल में हमारा तीर्थ',
      images: ['Raniwara_1.jpg', 'Raniwara_2.jpg', 'Raniwara_3.jpg', 'Raniwara_4.jpg'],
      content: [
        'जैसलमेर के पास लोद्रवा में पुरातन हिंगलाज मंदिर के प्रांगण में हमारे समाज के बंधु वर्ष में एक बार मेले के रूप में एकत्र होते रहे हैं। 1980 के दशक में समाज में संगठन व प्रकाशन के क्षेत्र में समाज में आयी क्रांति ने हम ब्रह्मक्षत्रिय बालकों को कुलदेवी हिंगलाज माता के चिंतन, सानिध्य व पूजन को और बढावा दिया और हमें माता के और समीप आने का अनुभव हुआ।',
        'इसी दौर में रानीवाड़ा में 1987 में रानीवाड़ा में मंदिर स्थापित करने के भाव से 9 परिवारों के मुखियाओं ने एक सभा की। बाद में भागली मंदिर के तत्कालीन पुजारीजी श्री जोगारामजी से मंदिर के प्रारुप के बारे में मार्गदर्शन देने का आग्रह किया गया। उन्होंने रानीवाड़ा मे उस स्थान, जहां आज मंदिर स्थित है, पर रात्रि विश्राम कर प्रातः काल संकेत दिया कि यहीं भव्य धाम बनेगा और दूर दूर से दर्शनार्थी आयेंगे।',
        'बस रानीवाड़ा व सांचोर के निष्ठावान हमारे बंधु जुट गये। अनेक स्थानों पर भ्रमण किया। समाज बंधुओं का साथ, सहयोग व योगदान मिलता गया और 1995 में मंदिर बनकर तैयार हो गया।',
        '1997 में ज्येष्ठ शुक्ल दशमी को मंदिर की भव्य व दिव्य प्राण प्रतिष्ठा हुयी। चार दिवसीय प्रतिष्ठा समारोह सिरे मंदिर, जालोर के गादिपति शांतिनाथजी महाराज व जोगारामजी महाराज के पावन सानिध्य में सम्पन्न हुआ, जिसमें समाज के हजारों बंधुओं ने भाग लिया।',
        'मां श्री हिंगलाज की विद्यमानता व प्रभाव ने रानीवाड़ा को तीर्थ बना दिया। अनेकानेक दर्शनार्थी आने लगे। प्रतिवर्ष मंदिर का पाटोत्सव आयोजित किया जाता है। रजत पाटोत्सव 2022 को सम्पन्न हुआ।'
      ],
      facilities: 'रानीवाड़ा धाम में यात्रियों के लिये सम्पूर्ण सुविधायें उपलब्ध हैं। परिसर में हॉल, कमरे, टेरेस शेड व रसोईघर बने हैं। प्रवास व भोजन प्रसाद की सुव्यवस्था है। सम्पूर्ण समाज के प्राप्त सहयोग से स्थापित श्री हिंगलाज मंदिर ट्रस्ट द्वारा प्रदत्त सुविधाओं का लाभ लेते हुये यहां समाज की सभायें व विवाह आदि समारोह भी आयोजित होते रहे हैं।',
      accessibility: 'रानीवाड़ा जालोर जिले में राजस्थान में गुजरात सीमा से 12 किलोमीटर पहले हैं। यह रेल व सड़क मार्ग से अच्छी प्रकार से जुड़ा है।',
      note: 'मां के साथ मां के भक्त, धाम स्थापित करने के स्वप्नद्रष्टा व योगदानकर्ता भी प्रणम्य हैं।'
    },
    {
      id: 'bhagali',
      name: 'भागली',
      nameEn: 'Bhagali',
      location: 'सुमेरपुर-जवांईबाध, पाली जिला, राजस्थान',
      locationEn: 'Sumerpur-Jawaiband, Pali District, Rajasthan',
      highlight: 'स्वयं प्रकट श्री हिंगलाज विराजमान',
      images: ['Bhagali_1.jpg', 'Bhagali_2.jpg'],
      content: [
        'राजस्थान में पाली जिले के सुमेरपुर-जवांईबाध से आगे भागली गांव में श्री हिंगलाज मंदिर क्षेत्रवासियों के लिये आस्था का केंद्र है।',
        'इससे ऊपर वीजापुर की पहाड़ियों की गुफा में श्री हरगंगा व श्री हिंगलाज माताजी का अलौकिक स्थान हैं। यहां गौमुख से जल प्रवाहित होता रहता है। इसे गंगा का स्वरूप माना जाता है। गुफा में ज्योति के दर्शन होते हैं। यहां स्वयं प्रकट श्री हिंगलाज विराजमान है।',
        'मां के इन स्थानों से हमारे बंधुओं का बहुत नाता है। भागली में प्रबंध देवासी बंधुओं का है लेकिन एक बार ब्रह्मक्षत्रिय बंधु वहां पहुंचा तो हिंगलाज माता ने अपने बालक को पहचान लिया व आशीर्वाद दिया।',
        'तभी से हमारे समाज के बंधु भागली मंदिर में न केवल दर्शनार्थ आते हैं बल्कि वहां के प्रबंधन का हिस्सा बनते हैं और निर्माण कार्य में भी योगदान देते हैं। हमारे कयी समाज बंधु हर महिने दर्शनार्थ आते हैं।',
        'यहां भरने वाले वार्षिक मेले में क्षेत्र के हजारों लोग शामिल होते हैं और हमारे बंधु भी काफी संख्या में पहुचते हैं।'
      ]
    },
    {
      id: 'siwana',
      name: 'सिवाना हिंगलाज माता',
      nameEn: 'Siwana Hinglaj Mata',
      location: 'सिवाना, बाड़मेर जिला, राजस्थान',
      locationEn: 'Siwana, Barmer District, Rajasthan',
      highlight: 'स्वयं प्रकट शक्ति, चमत्कार और आस्था का महासंगम',
      source: 'ब्रह्मक्षत्रिय मीडिया, बाड़मेर के सौजन्य से',
      images: ['Siwana_1.jpg', 'Siwana_2.jpg'],
      content: [
        'राजस्थान के सिवाना कस्बे में विराजित सिवाना हिंगलाज माता मंदिर केवल एक धार्मिक स्थल नहीं, बल्कि स्वयं प्रकट माँ हिंगलाज की जीवंत शक्ति का प्रमाण है। मान्यता है कि हजारों वर्ष पूर्व इस क्षेत्र में एक अत्याचारी राक्षस का आतंक था। उसी राक्षस के वध हेतु माँ हिंगलाज अपने रथ पर सवार होकर यहाँ प्रकट हुईं।',
        'आज भी सिवाना के पहाड़ों पर माँ के रथ के पहियों के निशान स्पष्ट दिखाई देते हैं। जब माता ने पहाड़ फाड़कर अवतार लिया, तब विशाल शिलाएँ नीचे बसे गाँव की ओर गिरने लगीं। ग्राम की रक्षा हेतु माँ ने अपने हाथ से एक विशाल पत्थर को रोक लिया, जो आज भी हवा में स्थिर अवस्था में स्थित है। यह चमत्कार श्रद्धालुओं को आज भी अचंभित करता है।',
        'कहा जाता है कि जिस राक्षस के वध के लिए माता प्रकट हुई थीं, उसकी चोटी पकड़कर छह किलोमीटर दूर स्थित "छोटी हिंगलाज" स्थान पर उसका संहार किया गया। वहाँ आज भी प्राचीन मंदिर विद्यमान है।',
        'लोक मान्यताओं के अनुसार पाकिस्तान के बलूचिस्तान स्थित हिंगलाज माता मंदिर से माँ आठ पहर में से दो पहर सिवाना हिंगलाज में साक्षात दर्शन देती हैं।'
      ],
      additionalSections: [
        {
          title: 'दामोदर पुरी जी महाराज की तपस्या',
          content: 'इस पावन शक्ति पीठ की सेवा के लिए गिरनार पर्वत से पधारे महान तपस्वी दामोदर पुरी जी महाराज को स्वयं माँ हिंगलाज ने बुलाया था। उनकी घोर तपस्या से प्रसन्न होकर माता ने उन्हें सेवा का सौभाग्य तथा अमरत्व का वरदान प्रदान किया। मान्यता है कि छठी सदी से लेकर आज तक उनके दर्शन होते रहे हैं। उनकी तपस्या की गुफा आज भी यहाँ विद्यमान है।'
        },
        {
          title: 'गंगाजल का चमत्कार',
          content: 'एक प्रसिद्ध चमत्कार के अनुसार, जब दामोदर पुरी जी हरिद्वार गंगाजल लेने जाना चाहते थे, तब माँ ने अपने चरण नख से भूमि पर ठोकर मारकर यहीं से गंगा जल प्रकट कर दिया। आज भी यह जल शुद्ध गंगाजल माना जाता है, जिसे हिंगलाज भक्त श्रद्धापूर्वक अपने घर ले जाते हैं।'
        },
        {
          title: 'जोधपुर महाराजा की परीक्षा और ताम्रपत्र की कथा',
          content: 'इतिहास में वर्णित है कि जब जोधपुर के महाराजा सिवाना पधारे, तब उन्हें बताया गया कि माँ द्वारा रोका गया यह विशाल पत्थर ऐसा है कि इसके नीचे से रस्सी निकाली जा सकती है। महाराजा ने इसे परखने के लिए अपने सिपाहियों को आदेश दिया। माँ हिंगलाज के चमत्कार से उस पत्थर के नीचे से वास्तव में रस्सी निकल आई। इस दिव्य प्रमाण को देखकर महाराजा अत्यंत प्रभावित हुए और उन्होंने ताम्रपत्र पर यह घोषित किया कि सिवाना हिंगलाज माता एक शक्ति पीठ है तथा इसकी सेवा-पूजा का अधिकार यहीं के गोस्वामी महाराजों (पुजारियों) को सौंप दिया।'
        },
        {
          title: 'सभी समाजों की कुलदेवी',
          content: 'माँ हिंगलाज खत्री समाज की कुलदेवी तो हैं ही, साथ ही सिवाना व आसपास के क्षेत्रों की अनेक जातियाँ और समाज उन्हें अपनी कुलदेवी के रूप में पूजते हैं। आज लगभग 500 गोस्वामी परिवार, पीढ़ी दर पीढ़ी, माँ की सेवा में समर्पित हैं। सिवाना और उसके आसपास की अधिकांश जातियाँ माँ हिंगलाज को ही अपनी आराध्य देवी मानती हैं। यही कारण है कि यह धाम सामूहिक आस्था, विश्वास और चमत्कारों का जीवंत केंद्र बना हुआ है।'
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="gradient-orange py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-white/80 text-sm mb-6">
            <a href="/" className="hover:text-white">Home</a>
            <span>›</span>
            <a href="#" className="hover:text-white">About Samaj</a>
            <span>›</span>
            <span>Hinglaj Temples</span>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Hinglaj Temples
            </h1>
            <p className="text-2xl text-white/95 font-medium mb-2">
              हिंगलाज मंदिर
            </p>
            <p className="text-lg text-white/90 leading-relaxed">
              श्री हिंगलाज माता के पावन धाम एवं शक्तिपीठ
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Introduction Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-primary/5 to-orange-50 rounded-2xl p-8 border border-primary/10 mb-12"
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
            <span className="text-3xl">🙏</span>
            श्री हिंगलाज माता - आदि शक्ति
          </h2>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              न केवल ब्रह्मक्षत्रिय बल्कि चारण, राजपूत आदि अनेक समाजों के बंधु श्री हिंगलाज को अपनी कुल देवी मानकर पूजा करते हैं। इस प्रभाव से अनेक स्थानों पर पुरातन व नवीन मंदिर - शक्ति पीठ विराजित हैं। जोधपुर के मेहरानगढ़ फोर्ट में श्री हिंगलाज की आदमकद चांदी की मूर्ति प्रतिष्ठित है। कुछ स्थानों पर स्वयं प्रकट शक्ति के रुप में श्री हिंगलाज विराजमान हैं।
            </p>
            <p>
              श्री हिंगलाज आदि शक्ति है और आस्थावान लोग इसी रुप में मानते हैं, महसूस करते हैं, ध्यान करते हैं, पूजते हैं। श्री हिंगलाज हमारी रक्षक देवी है, कुलदेवी है। इन्हीं से हमारा अस्तित्व है।
            </p>
            <div className="bg-white/60 rounded-xl p-4 border border-primary/10">
              <p className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-primary mt-1 flex-shrink-0" />
                <span>
                  <strong className="text-gray-900">मुख्य शक्तिपीठ:</strong> लसबेला, बलुचिस्तान में हैं। भारत में हिंगलाज के अनेक स्थान, धाम, पीठ व मंदिर हैं।
                </span>
              </p>
            </div>
            <p className="italic text-gray-600 border-l-4 border-primary/30 pl-4">
              हिंगलाज की महिमा व इनके स्थानों का वर्णन कर पाना हमारे वश में नहीं है। फिर भी मां को प्रणाम करते हुये कुछ स्थानों के बारे में लिखने का प्रयास कर रहे हैं।
            </p>
          </div>
        </motion.div>

        {/* Temple Cards */}
        <div className="space-y-6 mb-12">
          {temples.map((temple, index) => (
            <motion.div
              key={temple.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
            >
              {/* Temple Header */}
              <button
                onClick={() => toggleTemple(temple.id)}
                className="w-full px-6 py-5 flex items-center justify-between bg-gradient-to-r from-primary/5 to-transparent hover:from-primary/10 transition-colors"
              >
                <div className="flex items-center gap-4">
                  {/* Thumbnail */}
                  {temple.images && temple.images.length > 0 ? (
                    <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 border border-gray-200">
                      <img
                        src={`${BACKEND_URL}/api/static/temples/${temple.images[0]}`}
                        alt={temple.nameEn}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                  ) : (
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                      <Building2 className="w-6 h-6 text-primary" />
                    </div>
                  )}
                  <div className="text-left">
                    <h3 className="text-xl font-bold text-gray-900">{temple.name}</h3>
                    <div className="flex items-center gap-3 text-sm text-gray-500">
                      <span>{temple.nameEn}</span>
                      {temple.images && temple.images.length > 0 && (
                        <span className="flex items-center gap-1 text-blue-600">
                          <Image className="w-4 h-4" />
                          {temple.images.length} photos
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  {temple.highlight && (
                    <span className="hidden md:inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full">
                      {temple.highlight}
                    </span>
                  )}
                  {expandedTemple === temple.id ? (
                    <ChevronUp className="w-6 h-6 text-gray-400" />
                  ) : (
                    <ChevronDown className="w-6 h-6 text-gray-400" />
                  )}
                </div>
              </button>

              {/* Temple Content */}
              {expandedTemple === temple.id && (
                <div className="px-6 pb-6 border-t border-gray-100">
                  {/* Location & Contact Info */}
                  <div className="grid md:grid-cols-2 gap-4 py-4 mb-4 border-b border-gray-100">
                    <div className="flex items-start gap-3">
                      <MapPin className="w-5 h-5 text-primary mt-0.5" />
                      <div>
                        <p className="font-medium text-gray-900">{temple.location}</p>
                        <p className="text-sm text-gray-500">{temple.locationEn}</p>
                      </div>
                    </div>
                    {temple.contact && (
                      <div className="flex items-start gap-3">
                        <Phone className="w-5 h-5 text-primary mt-0.5" />
                        <div>
                          <p className="font-medium text-gray-900">सम्पर्क नम्बर</p>
                          <p className="text-sm text-gray-600">{temple.contact.join(', ')}</p>
                        </div>
                      </div>
                    )}
                    {temple.established && (
                      <div className="flex items-start gap-3">
                        <Calendar className="w-5 h-5 text-primary mt-0.5" />
                        <div>
                          <p className="font-medium text-gray-900">स्थापना</p>
                          <p className="text-sm text-gray-600">{temple.established}</p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Mobile highlight badge */}
                  {temple.highlight && (
                    <div className="md:hidden mb-4">
                      <span className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full">
                        {temple.highlight}
                      </span>
                    </div>
                  )}

                  {/* Image Gallery */}
                  {temple.images && temple.images.length > 0 && (
                    <div className="mb-6">
                      <h4 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                        <Image className="w-5 h-5 text-primary" />
                        फोटो गैलरी / Photo Gallery
                      </h4>
                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                        {temple.images.map((img, idx) => (
                          <a 
                            key={idx}
                            href={`${BACKEND_URL}/api/static/temples/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block aspect-square rounded-xl overflow-hidden border border-gray-200 hover:border-primary hover:shadow-lg transition-all"
                          >
                            <img
                              src={`${BACKEND_URL}/api/static/temples/${img}`}
                              alt={`${temple.nameEn} ${idx + 1}`}
                              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                              loading="lazy"
                            />
                          </a>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Main Content */}
                  <div className="space-y-4 text-gray-700 leading-relaxed">
                    {temple.content.map((para, idx) => (
                      <p key={idx}>{para}</p>
                    ))}
                  </div>

                  {/* Additional Sections (for Siwana) */}
                  {temple.additionalSections && (
                    <div className="mt-6 space-y-4">
                      {temple.additionalSections.map((section, idx) => (
                        <div key={idx} className="bg-gray-50 rounded-xl p-5">
                          <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                            <span className="w-2 h-2 bg-primary rounded-full"></span>
                            {section.title}
                          </h4>
                          <p className="text-gray-700 leading-relaxed">{section.content}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Facilities */}
                  {temple.facilities && (
                    <div className="mt-6 bg-green-50 rounded-xl p-5 border border-green-100">
                      <h4 className="font-bold text-green-800 mb-2 flex items-center gap-2">
                        <Users className="w-5 h-5" />
                        यात्री सुविधाएं
                      </h4>
                      <p className="text-green-700 leading-relaxed">{temple.facilities}</p>
                    </div>
                  )}

                  {/* Accessibility */}
                  {temple.accessibility && (
                    <div className="mt-4 bg-blue-50 rounded-xl p-5 border border-blue-100">
                      <h4 className="font-bold text-blue-800 mb-2 flex items-center gap-2">
                        <MapPin className="w-5 h-5" />
                        कैसे पहुंचे
                      </h4>
                      <p className="text-blue-700 leading-relaxed">{temple.accessibility}</p>
                    </div>
                  )}

                  {/* Note */}
                  {temple.note && (
                    <p className="mt-4 italic text-gray-600 border-l-4 border-primary/30 pl-4">
                      {temple.note}
                    </p>
                  )}

                  {/* Source */}
                  {temple.source && (
                    <p className="mt-4 text-sm text-gray-500 text-right">
                      ({temple.source})
                    </p>
                  )}
                </div>
              )}
            </motion.div>
          ))}
        </div>

        {/* Hinglaj Darshan Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-orange-500 to-primary rounded-2xl p-8 text-white"
        >
          <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
            <span className="text-3xl">🙏</span>
            हिंगलाज दर्शन
          </h2>
          <p className="text-white/90 leading-relaxed mb-6">
            विभिन्न स्थानों के हमारे समाज के भवनों में श्री हिंगलाज मंदिर स्थापित किये गये। उन मंदिरों में प्रतिष्ठित हिंगलाज माता के विग्रह के दर्शन करने के लिये नीचे दिए गए लिंक पर क्लिक कीजिए।
          </p>
          <a
            href="https://drive.google.com/drive/folders/1OX6Lt4qn0AVYLIyMBNe-0hiMBQsC7md3?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-primary px-6 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-colors shadow-lg"
          >
            <ExternalLink className="w-5 h-5" />
            हिंगलाज दर्शन फोल्डर देखें
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default TemplesPage;
